import {Button, Card} from "@chakra-ui/react"
import styled from "styled-components";
import {PiMapPinAreaLight, PiBuildingApartmentThin, PiBuildingThin} from "react-icons/pi";
import Parcel from "./parcel";
import Building from "./building";
import Apartment from "./apartment";
import {useNavigate} from "react-router";
import {responsive} from "../../../media-quries";


const Container = styled(Card.Root)`
  flex-direction: row;
  flex-wrap: wrap;
`;
const Footer = styled(Card.Footer)`
  padding: 12px 24px;
  border-left: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
`;
const Body = styled(Card.Body)`
  padding: 0;
  display: flex;
  flex-direction: column;

  ${responsive.sm`
    flex: 1;
  `}

  ${responsive.md`
    flex: 1;
  `}
`;
const SectionContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 12px;
  padding: 4px 8px;
`;
const SectionTitle = styled.div`
  font-size: 14px;
`;
const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

function Section({title, icon: Icon, color, children}) {

    return <SectionContainer>
        <SectionHeader style={{backgroundColor: color}}>
            <Icon/>
            <SectionTitle>{title}</SectionTitle>
        </SectionHeader>
        <ContentContainer>
            {children}
        </ContentContainer>
    </SectionContainer>
}

function RegisterElement({register, registerDetailsState}) {
    const {kw, budynki, dzialki, lokale} = register;
    const navigate = useNavigate();

    return <Container variant="elevated">
        <Body>
            {dzialki.length > 0 && <Section title="Działki" icon={PiMapPinAreaLight} color="#FFF8E1">
                {dzialki.map((parcel) => <Parcel key={`parcel-${parcel.lp}`} kw={kw} parcel={parcel}
                                                 registerDetailsState={registerDetailsState}/>)}
            </Section>}
            {budynki.length > 0 && <Section title="Budynki" icon={PiBuildingThin} color="#EBF4FA">
                {budynki.map((building) => <Building key={`parcel-${building.lp}`} kw={kw} building={building}
                                                     registerDetailsState={registerDetailsState}/>)}
            </Section>}
            {lokale.length > 0 && <Section title="Lokale" icon={PiBuildingApartmentThin} color="#E8F5E9">
                {lokale.map((apartment) => <Apartment key={`parcel-${apartment.lp}`} kw={kw} apartment={apartment}
                                                      registerDetailsState={registerDetailsState}/>)}
            </Section>}
        </Body>
        <Footer>
            <Button
                onClick={() => {
                    let lp;

                    if (dzialki?.length > 0) {
                        lp = `d${dzialki[0].lp}`;
                    } else if (budynki?.length > 0) {
                        lp = `b${budynki[0].lp}`;
                    } else {
                        lp = `l${lokale[0].lp}`;
                    }

                    navigate('/zamowienie', {
                        state: {
                            order: {
                                type: 'kw', register: {
                                    ...register,
                                    lp
                                }
                            }
                        }
                    })
                }}
            >{kw}</Button>
        </Footer>
    </Container>
}

export default RegisterElement;
